import { render, staticRenderFns } from "./IconClickEvent.vue?vue&type=template&id=8a5c24d4&"
import script from "./IconClickEvent.vue?vue&type=script&lang=js&"
export * from "./IconClickEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports